import React from "react";

import { Stack, Typography } from "@mui/material";

export const Head: React.FC = () => {
  return (
    <Stack sx={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
      <Typography sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "24px", color: "#071F35" }}>
        Cashflow Summary
      </Typography>
    </Stack>
  );
};
